import {onFind} from "@elements/init-modules-in-scope";
import {removeClass,addClass,on,findIn, findAllIn, hasClass} from '@elements/dom-utils';

const selectors = {
    base: '.js-order-probability',
    select: '.js-order-probability__select',
    container: '.js-order-probability__container',
};

export function init() {
    onFind(selectors.base, function (baseElement) {
        let container = findIn(selectors.container, baseElement);
        let select = findIn(selectors.select, baseElement);

        on('change', function() {
            let value = select.value;

            container.style.width = value + "%";
        }, select);

    },);
}